import { render, staticRenderFns } from "./IndexProductList.vue?vue&type=template&id=076107a1&scoped=true"
import script from "./IndexProductList.vue?vue&type=script&lang=js"
export * from "./IndexProductList.vue?vue&type=script&lang=js"
import style0 from "./IndexProductList.vue?vue&type=style&index=0&id=076107a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076107a1",
  null
  
)

export default component.exports